import { Button, Modal } from '@mui/material';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { toast } from 'react-toastify';

import LoadingBackdropWrapper from '@/components/Modal/common/LoadingBackdropWrapper';
import ModalBody from '@/components/Modal/common/ModalBody';
import { deleteUser } from '../data/userService';

const RemoveUserConfirmation = ({ open, userId, handleClose, onConfirm }) => {
  const [loading, setLoading] = useState(false);

  const onConfirmRemove = async () => {
    setLoading(true);
    try {
      await deleteUser(userId);
      setLoading(false);

      handleClose();
      toast.success('User deleted successfully');
      onConfirm();
    } catch (_error) {
      handleClose();
      setLoading(false);
      toast.error('Something went wrong');
    }
  };

  return (
    <LoadingBackdropWrapper backdropOpen={loading}>
      <Modal open={open} onClose={handleClose} aria-labelledby='modal-title'>
        <ModalBody>
          <p className='mb-2 font-semibold'>Are you sure you want to remove this user?</p>
          <div className='flex justify-end gap-[9px]'>
            <Button variant='contained' onClick={onConfirmRemove}>
              Confirm
            </Button>
            <Button variant='outlined' color='error' onClick={handleClose}>
              Cancel
            </Button>
          </div>
        </ModalBody>
      </Modal>
    </LoadingBackdropWrapper>
  );
};

RemoveUserConfirmation.propTypes = {
  open: PropTypes.bool,
  userId: PropTypes.number,
  handleClose: PropTypes.func,
  onConfirm: PropTypes.func,
};

export default RemoveUserConfirmation;
